import Captain from '../../assets/marvel/Captain.jpg'
import Hulk from '../../assets/marvel/Hulk.jpg'
import Ironman from '../../assets/marvel/Ironman.jpg'
import Spiderman from '../../assets/marvel/Spiderman.jpg'
import Thor from '../../assets/marvel/Thor.jpg'

export const subscription = [
    {
        id: 1,
        name: 'Peter Parker',
        position: 'Spiderman',
        image: Spiderman
    },
    {
        id: 2,
        name: 'Bruce Banner',
        position: 'Hulk',
        image: Hulk
    },
    {
        id: 3,
        name: 'Steve Rogue',
        position: 'Captain America',
        image: Captain
    },
    {
        id: 4,
        name: 'Tony Stark',
        position: 'Ironman',
        image: Ironman
    },
    {
        id: 5,
        name: 'Thor Odinson',
        position: 'Thor',
        image: Thor
    },
]